// Copyright 2026 Bitech.id. Licensed under the MIT License.

import type { StreamEndReason } from './types.js';

// Deliberately tiny and free of any rrweb import — this file is always
// bundled (statically imported by index.ts) so Trace correlation and the
// promote-on-error hook work even before the heavy recorder module has been
// dynamically imported, without paying for rrweb's bytes up front.

let currentSessionId: string | undefined;

/** Read by beforeSend to stamp tags.session_id on every Trace event, when a Stream session is active. */
export function getReplaySessionId(): string | undefined {
  return currentSessionId;
}

export function setReplaySessionId(sessionId: string | undefined): void {
  currentSessionId = sessionId;
}

type ErrorCapturedHook = () => void;

let onErrorCaptured: ErrorCapturedHook | undefined;

/** Called by beforeSend whenever an exception is about to be sent — a no-op until the stream module registers a hook. */
export function notifyErrorCaptured(): void {
  onErrorCaptured?.();
}

export function setErrorCapturedHook(hook: ErrorCapturedHook | undefined): void {
  onErrorCaptured = hook;
}

type StopRequestedHook = (reason: StreamEndReason) => void;

let onStopRequested: StopRequestedHook | undefined;

/** Ends the active Stream session early, e.g. on user consent withdrawal. A no-op if Stream isn't active. */
export function requestStreamStop(reason: StreamEndReason = 'user_optout'): void {
  onStopRequested?.(reason);
}

export function setStopRequestedHook(hook: StopRequestedHook | undefined): void {
  onStopRequested = hook;
}
